import { styled, makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import { DIRECTORY_RESULTS_MAX_WIDTH } from '@layouts/coaches-search/directory-results-layout'

export const useStyles = makeStyles((theme) => ({
  headlinePros: {
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
  member: {
    display: 'flex',
    flexDirection: 'row',
  },
  memberPhoto: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: theme.palette.grey.light,
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(2),
    flexShrink: 0,
  },
  memberType: {
    lineHeight: 1.5,
  },
  memberName: {
    fontSize: 20,
    marginBottom: theme.spacing(1),
  },
  memberTitle: {
    color: theme.palette.grey.dark,
  },
  facilityAddress: {
    display: 'flex',
    alignItems: 'center',
  },
  coachesWrapper: {
    maxWidth: DIRECTORY_RESULTS_MAX_WIDTH,
    [theme.breakpoints.only('xs')]: {
      justifyContent: 'center',
    },
  },
}))

export const FieldBox = styled(Box)(({ theme, icon }) => ({
  display: 'flex',
  alignItems: 'center',
  lineHeight: '20px',
  marginBottom: theme.spacing(1),
  '& svg': {
    marginRight: theme.spacing(1),
    marginLeft: icon === 'call' ? '0' : '-4px',
  },
}))

export const Image = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  display: 'block',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(-2),
  },
}))
